export const TAB_KEYCODE = 'Tab';
export const ENTER_KEYCODE = 'Enter';
export const L_SHIFT_KEYCODE = 'ShiftLeft';
export const R_SHIFT_KEYCODE = 'ShiftRight';
export const ESCAPE_KEYCODE = 'Escape';
export const SPACEBAR_KEYCODE = 'Space';
export const L_ARROW_KEYCODE = 'ArrowLeft';
export const U_ARROW_KEYCODE = 'ArrowUp';
export const R_ARROW_KEYCODE = 'ArrowRight';
export const D_ARROW_KEYCODE = 'ArrowDown';
export const HOME_KEYCODE = 'Home';
export const END_KEYCODE = 'End';
